import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const rewardAPI = createApi({
    reducerPath: "rewardAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllRewardMasterData: builder.query({
            query: () => {
                return {
                    url: '/rewards/master-data',
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["rewards_master_data"],
        }),
        updateRewardMasterData: builder.mutation({
            query: ({ body }) => ({
                url: `/rewards/master-data`,
                method: "PATCH",
                body
            }),
            invalidatesTags: ["rewards_master_data"],
        }),
        getAllRewardRedeemLogs: builder.mutation({
            query: ({ type, page, size, search }) => {
                let apiUrl = `/rewards/redemptions/${type}?page=${page + 1}&size=${size}`;

                if (search) {
                    apiUrl += `&searchTerm=${search}`;
                }
                
                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["rewardLogs"],
        }),

        getAllCampaigns: builder.mutation({
            query: ({ page, size, search }) => {
                let apiUrl = `/admin/campaigns?page=${page + 1}&size=${size}`;

                if (search) {
                    apiUrl += `&search=${search}`;
                }
                
                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["campaigns"],
        }),
        getCampaignByID: builder.mutation({
            query: ({ id }) => ({
                url: `admin/campaigns/${id}`,
                method: 'GET'
            }),
            transformResponse: (response) => response
        }),
        createCampaign: builder.mutation({
            query: ({ body }) => ({
                url: `admin/campaigns`,
                method: 'POST',
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['campaigns'],
        }),
        editCampaign: builder.mutation({
            query: ({ id, body }) => ({
                url: `admin/campaigns/${id}`,
                method: 'PUT',
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['campaigns'],
        }),
        deleteCampaign: builder.mutation({
            query: ({ id }) => ({
                url: `admin/campaigns/${id}`,
                method: 'DELETE',
                body: {}
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['campaigns'],
        }),
        getAllVendorsOfACampaign: builder.mutation({
            query: ({ id }) => ({
                url: `admin/campaigns/${id}/vendors`,
                method: 'GET'
            }),
            transformResponse: (response) => response
        }),
        assignVendorsToCampaign: builder.mutation({
            query: ({ id, body }) => ({
                url: `admin/campaigns/${id}/vendors`,
                method: 'POST',
                body,
            }),
            transformResponse: (response) => response
        }),
        removeVendorsFromCampaign: builder.mutation({
            query: ({ id, body }) => ({
                url: `admin/campaigns/${id}/vendors`,
                method: 'DELETE',
                body,
            }),
            transformResponse: (response) => response
        }),

        getAllPromos: builder.mutation({
            query: ({ page, size, search }) => {
                let apiUrl = `/admin/promos?page=${page + 1}&size=${size}`;

                if (search) {
                    apiUrl += `&search=${search}`;
                }
                
                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["promos"],
        }),
        getPromoByID: builder.mutation({
            query: ({ id }) => ({
                url: `admin/promos/${id}`,
                method: 'GET'
            }),
            transformResponse: (response) => response
        }),
        createPromo: builder.mutation({
            query: ({ body }) => ({
                url: `admin/promos`,
                method: 'POST',
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['promos'],
        }),
        editPromos: builder.mutation({
            query: ({ id, body }) => ({
                url: `admin/promos/${id}`,
                method: 'PUT',
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['promos'],
        }),
        deletePromo: builder.mutation({
            query: ({ id }) => ({
                url: `admin/promos/${id}`,
                method: 'DELETE',
                body: {}
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['promos'],
        }),
        changePromoStatus: builder.mutation({
            query: ({ id, body }) => ({
                url: `admin/promos/${id}/status`,
                method: 'PATCH',
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['promos'],
        }),
        getAllPromoLogs: builder.mutation({
            query: ({ page, size, search }) => {
                let apiUrl = `/admin/promos/redemptions?page=${page + 1}&size=${size}`;

                if (search) {
                    apiUrl += `&searchTerm=${search}`;
                }
                
                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
    })
});

export const { 
    useGetAllRewardMasterDataQuery,
    useUpdateRewardMasterDataMutation,
    useGetAllRewardRedeemLogsMutation,

    useGetAllCampaignsMutation,
    useGetCampaignByIDMutation,
    useCreateCampaignMutation,
    useEditCampaignMutation,
    useDeleteCampaignMutation,
    useGetAllVendorsOfACampaignMutation,
    useAssignVendorsToCampaignMutation,
    useRemoveVendorsFromCampaignMutation,

    useGetAllPromosMutation,
    useGetPromoByIDMutation,
    useCreatePromoMutation,
    useEditPromosMutation,
    useDeletePromoMutation,
    useChangePromoStatusMutation,
    useGetAllPromoLogsMutation
} = rewardAPI;

export default rewardAPI;